import Http from '../index.js'
import Model from '../Model.js'

class Notifications extends Model {
  constructor() {
    super('/notifications/')
  }

  listNotifications(query = '') {
    return Http.get(`${this.model}list_notifications/${query}`)
  }

  notificationSettings() {
    return Http.get(`${this.model}notification_settings/`)
  }

  markAsRead(id) {
    return Http.post(`${this.model}mark_read/`, { notification_id: id })
  }

  markAllAsRead() {
    return Http.post(`${this.model}mark_all_read/`)
  }

  getNotificationsSettings(query = '') {
    return Http.get(`${this.model}notification_settings/${query}`)
  }

  updateUserNotificationsSettings(payload) {
    return Http.post(`${this.model}update_notification_user/`, payload)
  }

  updateClientNotificationsSettings(payload) {
    return Http.post(`${this.model}update_notifications_client/`, payload)
  }
}

export default new Notifications()
